// Implements: F-SHR-013
/**
 * Mockup v3 P8: what "Ver como visitante" frames for a listed link: its mockup, its artifact and,
 * for a fixed link, the version it keeps (a live link shows the mockup's current version). The frame
 * asks by the link's id alone (owner 2026-10-19), so anyone who sees the link may preview it.
 */

import type { ShareLinkView, VisitorPreviewTarget } from "../../../types/sharing";

export function visitorTargetOf(link: ShareLinkView, label: string): VisitorPreviewTarget {
  return {
    mockupId: link.mockup_id,
    artifact: link.artifact === "diagram" ? "diagram" : "prototype",
    versionId: link.mode === "frozen" ? link.frozen_version_id : null,
    linkId: link.id,
    label,
  };
}
